// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1aLD_","location":"Header_location__Yudfj"};